export default __webpack_public_path__ + "86f92d5a97825c736e4823cebcc8cf77.svg";